import {
  Card,
  CardContent,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../../context/user-context";
import { useTranslation } from "../../../hooks/useTranslation";
import { hiddenAuthorization } from "../../../store/actions/userAction";
import { AuthorizationType } from "../../../store/types/userTypes";

type CardAuthorizationProps = {
  title: string;
  type?: AuthorizationType;
  children?: React.ReactNode;
};

const useStyles = makeStyles({
  root: {
    borderRadius: 0,
    marginBlock: 10,
    boxShadow:
      "0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 24px rgba(51, 51, 51, 0.24)",
  },
  cardContent: {
    paddingBottom: "12px !important",
  },
});

export const CardAuthorization = ({
  title,
  type,
  children,
}: CardAuthorizationProps) => {
  const classes = useStyles();
  const [hidden, setHidden] = useState(false);
  const [countHidden, setCountHidden] = useState(0);
  const { t, BundleKey } = useTranslation();
  const { state, dispatch } = useContext(UserContext);

  const toggleHidden = () => {
    if (type) {
      state.authorizations.map((item) => {
        if (!item.mark && item.type === type) {
          dispatch(hiddenAuthorization(item.id, type));
        }
      });
    }
  };

  useEffect(() => {
    const findHidden = state.authorizations.some(
      (item) => item.hidden && item.type === type
    );
    if (type && findHidden) {
      let count = 0;
      state.authorizations.map((item) => {
        if (!item.mark && !item.hidden && item.type === type) {
          dispatch(hiddenAuthorization(item.id, type));
        }
        if (!item.mark && item.hidden && item.type === type) {
          count++;
        }
      });
      setCountHidden(count);
    }
    setHidden(findHidden);
  }, [JSON.stringify(state.authorizations)]);

  return (
    <Card className={classes.root}>
      <CardContent className={classes.cardContent}>
        <Grid container direction="column" justifyContent="flex-start">
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={11}>
                <Typography
                  color="primary"
                  variant="body1"
                  style={{ fontSize: "1.1em" }}
                >
                  {title}
                </Typography>
                {hidden ? (
                  <Typography color="primary" variant="body1">
                    {`${countHidden} ${t(BundleKey.DETAIL_AUTHORIZATION_HIDE)}`}
                  </Typography>
                ) : null}
              </Grid>
              <Grid
                item
                xs={1}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <IconButton
                  color="primary"
                  style={{ padding: "5px" }}
                  onClick={toggleHidden}
                >
                  {hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
};
